/**
 * Generatory gotowych zapytań dla akcji z menu drzewa (Wyświetl dane, Skrypt SELECT).
 * Identyfikatory cytujemy tylko gdy trzeba (wielkie litery, znaki spoza [a-z0-9_]).
 */

import type { DbRelation } from './types';

export function quoteIdent(name: string): string {
  return /^[a-z_][a-z0-9_]*$/.test(name) ? name : `"${name.replace(/"/g, '""')}"`;
}

export type ViewDataMode = 'first' | 'last' | 'all' | 'filter';

export function viewDataSql(
  schema: string,
  rel: DbRelation,
  mode: ViewDataMode,
  where?: string,
): string {
  const from = `${quoteIdent(schema)}.${quoteIdent(rel.name)}`;
  const pk = rel.columns.find((c) => c.isPrimaryKey)?.name ?? rel.columns[0]?.name;
  const order = pk ? `\nORDER BY ${quoteIdent(pk)} ${mode === 'last' ? 'DESC' : 'ASC'}` : '';
  if (mode === 'filter') {
    return `SELECT * FROM ${from}\nWHERE ${where?.trim() || 'true'}${order}`;
  }
  if (mode === 'all') return `SELECT * FROM ${from}${order}`;
  return `SELECT * FROM ${from}${order}\nLIMIT 100`;
}

export function selectScript(schema: string, rel: DbRelation): string {
  const cols = rel.columns.map((c) => `\t${quoteIdent(c.name)}`).join(',\n');
  return `SELECT\n${cols}\nFROM ${quoteIdent(schema)}.${quoteIdent(rel.name)};`;
}
